module.exports = __webpack_public_path__ + "img/pic_usa_03.734afac3.jpg";